import script from "./SideMenuComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideMenuComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SideMenuComponent.vue?vue&type=style&index=0&id=747f0380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-747f0380"]])

export default __exports__